import getItemStyles from '../../../utils/item-styles.js';
import dayjs from 'dayjs';
import fixAmAndPm from '../../../../../utils/fixAmAndPm.js';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck.js';

/**
 * Returns a meal item that can be displayed in the seven to nine day schedule. It will be displayed in the day of the
 * parent tour's start time. The styling will be created by calling getItemStyle.
 * @param {*} rId
 * @param {*} dayType
 */
const generateMeal = (rId, dayType, tourStartTime, timeOffset, startDate, scheduleType, scheduleFormat, scheduleLength) => {
  const { rdtId, tour } = dayType;
  const { meal } = tour;
  const { mealId, red, mealTime, mealEndTime, isApproved } = meal;
  const mealStyle = getItemStyles('meal');


  const mealStartTime = dayjs(dayjs.unix(mealTime).utc().format("YYYY-MM-DD HH:mm:ss"));
  const endTime = dayjs(dayjs.unix(mealEndTime).utc().format("YYYY-MM-DD HH:mm:ss"));

  let DSTNeutralMealStartTime =mealStartTime;
  let DSTNeutralMealEndTime = endTime;

  
  const adjustedMeal = {
    id: mealId,
    rdtId,
    group: rId,
    itemType: 'meal',
    start_time: mealStartTime.startOf('day'),
    end_time: mealStartTime.endOf('day'),
    title: fixAmAndPm(DSTNeutralMealStartTime.format('h:mma')) + '-'
      + fixAmAndPm(DSTNeutralMealEndTime.format('h:mma')),
    backgroundColor: meal.isApproved ? 'gray': red ? 'red' : mealStyle.backgroundColor,
    color: 'black',
    borderStyle: mealStyle.borderStyle,
    borderColor: mealStyle.borderColor,
    isApproved
  };
  return adjustedMeal;
}

export default generateMeal;
